import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { PostTable } from '@app/components/apps/Post/PostTable';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { NominalPaymentsTable } from '@app/components/apps/NominalPayments/NominalPaymentsTable';

const AllNominalPayments: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  function handleCreateClick(): void {
    navigate('/add-nominal-payment');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: '/nominal-payments', breadcrumbName: 'Nominal Payments' }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Add Post',
      <BaseButton type="primary" size="small" onClick={handleCreateClick}>
        Create
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, []);

  return (
    <>
      <PageTitle>Nominal Payments</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <NominalPaymentsTable />
        </Col>
      </Row>
    </>
  );
};

export default AllNominalPayments;
